// extracted by mini-css-extract-plugin
module.exports = {"Link":"src-components-ExternalLink-styles__Link--1hGBW"};